<div class="ibox">
    <iboxtools *ngIf="seguridadSocial != null"
               [Title]=""
               [isHistory]=true
               [DateInit]="seguridadSocial?.desde"
               [DateEnd]="seguridadSocial?.hasta"
               [PeriodList]="seguridadSocialList"
               [IsEditing]="isEditing"
               (PeriodChange)="OnPeriodChange($event)"
               (NewChange)="OnNewChange($event)"
               (EditChange)="OnEditChange($event)"
               (SaveChange)="OnSaveChange($event)"
               (CutChange)="OnCutChange($event)"
               (DeleteChange)="OnDeleteChange($event)"
               (CancelChange)="OnCancelChange($event)"
               [Permiso]="permisoEdicion">
    </iboxtools>
    <div class="ibox-content" *ngIf="seguridadSocial != null">
      <mat-error *ngIf="datosInvalida" class="datosInvalida">{{MensajeError}}</mat-error>
      <form [formGroup]="form">
        <div class="row" hidden="true">
          <input formControlName="id" name="id" type="text" class="form-control" />
          <input formControlName="personal" name="personal" type="text" class="form-control" />
        </div>
        <div class="row panel panel-warning" *ngIf="!disabledEditing">
          <div class="col-lg">
            <label class="col-lg-3 col-form-label font-bold" for="desde">Desde</label>
            <div class="col-lg-8">
              <p-calendar appendTo="body" selectOtherMonths="true" formControlName="desde" required dateFormat="dd/mm/yy" inputId="desde" ngDefaultControl (ngModelChange)="onChangeFechas()"></p-calendar>
              <div *ngIf="registerFormControl.desde.errors?.required && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched || submitted)" class="text-danger">La Fecha es requerida</div>
              <mat-error *ngIf="registerFormControl.desde.errors?.desdeAnterior && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched || submitted)" class="text-danger">
                No puede ser anterior al ingreso {{ingreso.desde | date:'dd/MM/yyyy'}}
              </mat-error>
              <mat-error *ngIf="registerFormControl.desde.errors?.anteriorRetroactividad && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched || submitted)" class="text-danger">
                No puede ser anterior al límite de retroactividad {{gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd | date:'dd/MM/yyyy'}}
              </mat-error>
            </div>
          </div>
          <div class="col-lg">
            <label class="col-lg-3 col-form-label font-bold" for="hasta">Hasta</label>
            <div class="col-lg-8">
              <p-calendar appendTo="body" selectOtherMonths="true" formControlName="hasta" required dateFormat="dd/mm/yy" inputId="hasta" ngDefaultControl (ngModelChange)="onChangeFechas()"></p-calendar>
              <div *ngIf="registerFormControl.hasta.errors?.required && (registerFormControl.hasta?.dirty || registerFormControl.hasta?.touched || submitted)" class="text-danger">La Fecha es requerida</div>
              <mat-error  class="text-danger" *ngIf="registerFormControl.hasta.errors?.fecHastaMenor && (registerFormControl.hasta?.dirty || registerFormControl.hasta?.touched || submitted)">
                La Fecha no puede ser menor que la Fecha Desde
              </mat-error>
            </div>
          </div>
        </div>
        <div class="row">
            <div class="col-lg">
                <label class="col-form-label font-bold">Obra Social</label>
                <div>
                  <comboTools [list]=obraSocialList
                              selected='obraSocial'
                              [formParent]="form"
                              [isEditing]=disabledEditing
                              filter="descripcion"
                              (SelectedChange)="onChangeObrasocial($event)"></comboTools>
                  <div *ngIf="registerFormControl.obraSocial.invalid && (registerFormControl.obraSocial?.dirty || registerFormControl.obraSocial?.touched || submitted)" class="text-danger">
                    La Obra Social es Requerida
                  </div>
                </div>
            </div>
            <div class="col-lg">
                <label class="col-form-label font-bold">Plan Obra Social</label>
                <div>
                  <comboTools [list]=planObraSocialList
                              selected='planObraSocial'
                              [formParent]="form"
                              [isEditing]=disabledEditing
                              filter="descripcion"></comboTools>
                  <div *ngIf="registerFormControl.planObraSocial.invalid && (registerFormControl.planObraSocial?.dirty || registerFormControl.planObraSocial?.touched || submitted)" class="text-danger">
                    El Plan Obra Social es Requerido
                  </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg">
                <div class="form-group">
                    <label class=" col-form-label font-bold">Nro de Afiliado</label>
                    <input formControlName="nroAfiliado" maxlength="25" name ="selectednroAfiliado" type="text" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.nroAfiliado.errors && (registerFormControl.nroAfiliado?.dirty || registerFormControl.nroAfiliado?.touched || submitted)}"/>
                    <mat-error  class="text-danger"*ngIf="registerFormControl.nroAfiliado.errors?.required && (registerFormControl.nroAfiliado?.dirty || registerFormControl.nroAfiliado?.touched || submitted)">
                        El Nro de Afiliado es Requerido
                    </mat-error>
                </div>
            </div>
            <div class="col-lg">
                <label class="col-form-label font-bold">Actividad Empleado</label>
                <div>
                  <comboTools [list]=actividadList
                              selected='actividadEmpleado'
                              [formParent]="form"
                              [isEditing]=disabledEditing
                              filter="descripcion"></comboTools>
                  <div *ngIf="registerFormControl.actividadEmpleado.invalid && (registerFormControl.actividadEmpleado?.dirty || registerFormControl.actividadEmpleado?.touched || submitted)" class="text-danger">
                    La Actividad del Empleado es Requerida
                  </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <label class="col-form-label font-bold">Agrupamiento Empleado</label>
                <div>
                  <comboTools [list]=agrupamientoList
                              selected='agrupamientoEmpleado'
                              [formParent]="form"
                              [isEditing]=disabledEditing
                              filter="descripcion"></comboTools>
                  <div *ngIf="registerFormControl.agrupamientoEmpleado.invalid && (registerFormControl.agrupamientoEmpleado?.dirty || registerFormControl.agrupamientoEmpleado?.touched || submitted)" class="text-danger">
                    El Agrupamiento del Empleado es Requerido
                  </div>
                </div>
            </div>
            <div class="col-md-6">
                <label class="col-form-label font-bold">Carácter de Servicio</label>
                <div>
                  <comboTools [list]=caracterList
                              selected='caracterServicio'
                              [formParent]="form"
                              [isEditing]=disabledEditing
                              filter="descripcion"></comboTools>
                  <div *ngIf="registerFormControl.caracterServicio.invalid && (registerFormControl.caracterServicio?.dirty || registerFormControl.caracterServicio?.touched || submitted)" class="text-danger">
                    El Carácter de Servicio es Requerido
                  </div>
                </div>
            </div>
        </div>
        
      </form>
    </div>
  </div>
  
  <div class="ibox-content m-b-sm border-bottom" *ngIf="seguridadSocial == null && cargaCompleta">
    <button type="button" pButton pRipple pTooltip="Agregar" tooltipPosition="bottom" icon="pi pi-plus" class="btn btn-sm btn-primary pull-right" (click)='add()'></button>
    <div class="p-xs">
      <div class="float-left m-r-md">
        <i class="fa fa-globe text-navy mid-icon"></i>
      </div>
      <h2>Empleado sin Datos de Seguridad Social</h2>
      <span>El empleado no tiene Datos de Seguridad Social.</span>
    </div>
  </div>
  
  
  